"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.DEFAULTS = exports.default = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _DEFAULTS;

var KEYS = {
  CURRENCY: 'contacts:currency_type',
  TIME_ZONE: 'hubspot:timezone',
  ACCOUNT_NAME: 'companyFooter',
  LEAD_REVISIT_NOTIFICATIONS_ENABLED: 'LeadRevisitNotificationsEnabled',
  GDPR_COMPLIANCE_ENABLED: 'GDPRComplianceEnabled',
  GDPR_ENFORCEMENT_ENABLED: 'GDPREnforcementEnabled',
  GDPR_UNSUBSCRIBE_LINK_ENABLED: 'gdprUnsubscribeLinkEnabled',
  EMAIL_SERVICES_OPEN_TRACKING_ANONYMIZATION_ENABLED: 'EmailServicesOpenTrackingAnonymizationEnabled',
  ECOMMERCE_ENABLED: 'integrations:ecommerce:enabled',
  ECOMMERCE_GET_STARTED_DISMISSED: 'integrations:ecommerce:get-started-dismissed',
  ECOMMERCE_WORKFLOWS_BANNER_DISMISSED: 'integrations:ecommerce:workflows-banner-dismissed',
  EMAIL_FREQUENCY_ENABLED: 'email:recipientFatigueSuppression:enabled',
  EMAIL_FREQUENCY_LIMIT: 'email:recipientFatigueSuppression:limit',
  EMAIL_FREQUENCY_DAYS: 'email:recipientFatigueSuppression:days',
  EMAIL_UNSUB_SURVEY_ENABLED: 'email:unsubscribeSurveyEnabled'
};
var _default = KEYS;
exports.default = _default;
var DEFAULTS = (_DEFAULTS = {}, (0, _defineProperty2.default)(_DEFAULTS, KEYS.CURRENCY, 'USD'), (0, _defineProperty2.default)(_DEFAULTS, KEYS.TIME_ZONE, 'US/Eastern'), (0, _defineProperty2.default)(_DEFAULTS, KEYS.LEAD_REVISIT_NOTIFICATIONS_ENABLED, 'false'), (0, _defineProperty2.default)(_DEFAULTS, KEYS.GDPR_COMPLIANCE_ENABLED, 'false'), (0, _defineProperty2.default)(_DEFAULTS, KEYS.GDPR_ENFORCEMENT_ENABLED, 'false'), (0, _defineProperty2.default)(_DEFAULTS, KEYS.GDPR_UNSUBSCRIBE_LINK_ENABLED, 'false'), (0, _defineProperty2.default)(_DEFAULTS, KEYS.ECOMMERCE_ENABLED, 'false'), (0, _defineProperty2.default)(_DEFAULTS, KEYS.ECOMMERCE_GET_STARTED_DISMISSED, 'false'), (0, _defineProperty2.default)(_DEFAULTS, KEYS.ECOMMERCE_WORKFLOWS_BANNER_DISMISSED, 'false'), (0, _defineProperty2.default)(_DEFAULTS, KEYS.EMAIL_FREQUENCY_ENABLED, 'false'), (0, _defineProperty2.default)(_DEFAULTS, KEYS.EMAIL_FREQUENCY_LIMIT, '4'), (0, _defineProperty2.default)(_DEFAULTS, KEYS.EMAIL_FREQUENCY_DAYS, '7'), (0, _defineProperty2.default)(_DEFAULTS, KEYS.EMAIL_UNSUB_SURVEY_ENABLED, 'false'), (0, _defineProperty2.default)(_DEFAULTS, KEYS.EMAIL_SERVICES_OPEN_TRACKING_ANONYMIZATION_ENABLED, 'false'), _DEFAULTS);
exports.DEFAULTS = DEFAULTS;